(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[12],{

/***/ 57976:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
var __webpack_unused_export__;


var _interopRequireDefault = __webpack_require__(64836);
__webpack_unused_export__ = ({
  value: true
});
exports.Z = void 0;
var _createSvgIcon = _interopRequireDefault(__webpack_require__(64938));
var _jsxRuntime = __webpack_require__(85893);
var _default = (0, _createSvgIcon.default)( /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
  d: "M12 8c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2zm0 2c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm0 6c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2z"
}), 'MoreVert');
exports.Z = _default;

/***/ }),

/***/ 11775:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
var __webpack_unused_export__;


var _interopRequireDefault = __webpack_require__(64836);
__webpack_unused_export__ = ({
  value: true
});
exports.Z = void 0;
var _createSvgIcon = _interopRequireDefault(__webpack_require__(64938));
var _jsxRuntime = __webpack_require__(85893);
var _default = (0, _createSvgIcon.default)( /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
  d: "m4.01 6.03 7.51 3.22-7.52-1 .01-2.22m7.5 8.72L4 17.97v-2.22l7.51-1M2.01 3 2 10l15 2-15 2 .01 7L23 12 2.01 3z"
}), 'SendOutlined');
exports.Z = _default;

/***/ }),

/***/ 61225:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
var react__WEBPACK_IMPORTED_MODULE_0___namespace_cache;
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ useMediaQuery; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _mui_system__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(34168);
/* harmony import */ var _mui_system__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(20539);
/* harmony import */ var _utils_useEnhancedEffect__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(63289);




/**
 * @deprecated Not used internally. Use `MediaQueryListEvent` from lib.dom.d.ts instead.
 */

function useMediaQueryOld(query, defaultMatches, matchMedia, ssrMatchMedia, noSsr) {
  const supportMatchMedia = typeof window !== 'undefined' && typeof window.matchMedia !== 'undefined';
  const [match, setMatch] = react__WEBPACK_IMPORTED_MODULE_0__.useState(() => {
    if (noSsr && supportMatchMedia) {
      return matchMedia(query).matches;
    }
    if (ssrMatchMedia) {
      return ssrMatchMedia(query).matches;
    }

    // Once the component is mounted, we rely on the
    // event listeners to return the correct matches value.
    return defaultMatches;
  });
  (0,_utils_useEnhancedEffect__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(() => {
    let active = true;
    if (!supportMatchMedia) {
      return undefined;
    }
    const queryList = matchMedia(query);
    const updateMatch = () => {
      // Workaround Safari wrong implementation of matchMedia
      // TODO can we remove it?
      // https://github.com/mui/material-ui/pull/17315#issuecomment-528286677
      if (active) {
        setMatch(queryList.matches);
      }
    };
    updateMatch();
    // TODO: Use `addEventListener` once support for Safari < 14 is dropped
    queryList.addListener(updateMatch);
    return () => {
      active = false;
      queryList.removeListener(updateMatch);
    };
  }, [query, matchMedia, supportMatchMedia]);
  return match;
}

// eslint-disable-next-line no-useless-concat -- Workaround for https://github.com/webpack/webpack/issues/14814
const maybeReactUseSyncExternalStore = /*#__PURE__*/ (react__WEBPACK_IMPORTED_MODULE_0___namespace_cache || (react__WEBPACK_IMPORTED_MODULE_0___namespace_cache = __webpack_require__.t(react__WEBPACK_IMPORTED_MODULE_0__, 2)))['useSyncExternalStore' + ''];
function useMediaQueryNew(query, defaultMatches, matchMedia, ssrMatchMedia) {
  const getDefaultSnapshot = react__WEBPACK_IMPORTED_MODULE_0__.useCallback(() => defaultMatches, [defaultMatches]);
  const getServerSnapshot = react__WEBPACK_IMPORTED_MODULE_0__.useMemo(() => {
    if (ssrMatchMedia !== null) {
      const {
        matches
      } = ssrMatchMedia(query);
      return () => matches;
    }
    return getDefaultSnapshot;
  }, [getDefaultSnapshot, query, ssrMatchMedia]);
  const [getSnapshot, subscribe] = react__WEBPACK_IMPORTED_MODULE_0__.useMemo(() => {
    if (matchMedia === null) {
      return [getDefaultSnapshot, () => () => {}];
    }
    const mediaQueryList = matchMedia(query);
    return [() => mediaQueryList.matches, notify => {
      // TODO: Use `addEventListener` once support for Safari < 14 is dropped
      mediaQueryList.addListener(notify);
      return () => {
        mediaQueryList.removeListener(notify);
      };
    }];
  }, [getDefaultSnapshot, matchMedia, query]);
  const match = maybeReactUseSyncExternalStore(subscribe, getSnapshot, getServerSnapshot);
  return match;
}
function useMediaQuery(queryInput, options = {}) {
  const theme = (0,_mui_system__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)();
  // Wait for jsdom to support the match media feature.
  // All the browsers MUI support have this built-in.
  // This defensive check is here for simplicity.
  // Most of the time, the match media logic isn't central to people tests.
  const supportMatchMedia = typeof window !== 'undefined' && typeof window.matchMedia !== 'undefined';
  const {
    defaultMatches = false,
    matchMedia = supportMatchMedia ? window.matchMedia : null,
    ssrMatchMedia = null,
    noSsr
  } = (0,_mui_system__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({
    name: 'MuiUseMediaQuery',
    props: options,
    theme
  });
  if (false) {}
  let query = typeof queryInput === 'function' ? queryInput(theme) : queryInput;
  query = query.replace(/^@media( ?)/m, '');

  // TODO: Drop `useMediaQueryOld` and use  `use-sync-external-store` shim in `useMediaQueryNew` once the package is stable
  const useMediaQueryImplementation = maybeReactUseSyncExternalStore !== undefined ? useMediaQueryNew : useMediaQueryOld;
  const match = useMediaQueryImplementation(query, defaultMatches, matchMedia, ssrMatchMedia, noSsr);
  if (false) {}
  return match;
}

/***/ }),

/***/ 93060:
/***/ (function(module) {

"use strict";
/* eslint-disable import/no-relative-packages */ /** @type {import('next-sitemap').IConfig} */ 
module.exports = {
    siteUrl: "https://blockquiry.com",
    generateRobotsTxt: true,
    blockQuiry_connect_secret: "GB8#p*ko7Mp]oJ8iTO2ItDcvtw{i5;k5vks/GTy;f;#p}3*.q!A-G][.-|='HghXf;uIU'VU-r1VJRtiJcVW'FXT9wuLX'+T8wkcm?zL).}1d*a",
    // baseUrlApp: 'http://13.49.44.48:3000/',
    baseUrlApp: "http://localhost:3000/"
};


/***/ }),

/***/ 45581:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ message_app; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(29815);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/Typography/Typography.js + 1 modules
var Typography = __webpack_require__(29630);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/useMediaQuery/useMediaQuery.js
var useMediaQuery = __webpack_require__(61225);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/Box/Box.js
var Box = __webpack_require__(30120);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/AppBar/AppBar.js + 1 modules
var AppBar = __webpack_require__(85050);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/Toolbar/Toolbar.js + 1 modules
var Toolbar = __webpack_require__(20784);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/Card/Card.js + 1 modules
var Card = __webpack_require__(49837);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/CardHeader/CardHeader.js + 1 modules
var CardHeader = __webpack_require__(59742);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/Avatar/Avatar.js + 2 modules
var Avatar = __webpack_require__(44731);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/Button/Button.js + 1 modules
var Button = __webpack_require__(54225);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/IconButton/IconButton.js + 1 modules
var IconButton = __webpack_require__(80562);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/Paper/Paper.js + 2 modules
var Paper = __webpack_require__(81401);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/InputBase/InputBase.js + 1 modules
var InputBase = __webpack_require__(70877);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/Divider/Divider.js
var Divider = __webpack_require__(44373);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/Grid/Grid.js + 2 modules
var Grid = __webpack_require__(79072);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/Dialog/Dialog.js
var Dialog = __webpack_require__(29620);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/DialogActions/DialogActions.js + 1 modules
var DialogActions = __webpack_require__(76779);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/DialogContent/DialogContent.js + 1 modules
var DialogContent = __webpack_require__(95398);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/DialogContentText/DialogContentText.js + 1 modules
var DialogContentText = __webpack_require__(44642);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/DialogTitle/DialogTitle.js
var DialogTitle = __webpack_require__(77745);
// EXTERNAL MODULE: ./node_modules/formik-mui/dist/esm/TextField.js + 1 modules
var TextField = __webpack_require__(20990);
// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(5152);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/axios/lib/axios.js + 39 modules
var axios = __webpack_require__(70594);
// EXTERNAL MODULE: ./node_modules/copy-to-clipboard/index.js
var copy_to_clipboard = __webpack_require__(20640);
var copy_to_clipboard_default = /*#__PURE__*/__webpack_require__.n(copy_to_clipboard);
// EXTERNAL MODULE: ./node_modules/crypto-js/index.js
var crypto_js = __webpack_require__(81354);
// EXTERNAL MODULE: ./node_modules/formik/dist/formik.esm.js + 83 modules
var formik_esm = __webpack_require__(34011);
// EXTERNAL MODULE: ./node_modules/socket.io-client/build/esm/index.js + 29 modules
var esm = __webpack_require__(53920);
// EXTERNAL MODULE: ./node_modules/yup/es/index.js + 25 modules
var es = __webpack_require__(74231);
// EXTERNAL MODULE: ./next-sitemap.config.js
var next_sitemap_config = __webpack_require__(93060);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/styles/useTheme.js
var useTheme = __webpack_require__(62097);
// EXTERNAL MODULE: ./node_modules/@mui/system/esm/styled.js
var styled = __webpack_require__(13264);
// EXTERNAL MODULE: ./src/tokens.js
var tokens = __webpack_require__(5786);
// EXTERNAL MODULE: ./node_modules/@mui/icons-material/ArrowBackOutlined.js
var ArrowBackOutlined = __webpack_require__(96471);
// EXTERNAL MODULE: ./node_modules/@mui/icons-material/Link.js
var Link = __webpack_require__(43800);
// EXTERNAL MODULE: ./node_modules/@mui/icons-material/MoreVert.js
var MoreVert = __webpack_require__(57976);
// EXTERNAL MODULE: ./node_modules/@mui/icons-material/SendOutlined.js
var SendOutlined = __webpack_require__(11775);
// EXTERNAL MODULE: ./node_modules/@mui/icons-material/UploadFileOutlined.js
var UploadFileOutlined = __webpack_require__(70724);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(99534);
// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__(70655);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(45697);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/styles/styled.js
var styles_styled = __webpack_require__(81719);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/Snackbar/Snackbar.js + 3 modules
var Snackbar = __webpack_require__(17155);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/Alert/Alert.js + 5 modules
var Alert = __webpack_require__(19604);
// EXTERNAL MODULE: ./node_modules/@mui/icons-material/QrCode2.js
var QrCode2 = __webpack_require__(35142);
// EXTERNAL MODULE: ./node_modules/@mui/icons-material/IosShare.js
var IosShare = __webpack_require__(69773);
;// CONCATENATED MODULE: ./src/components/messages/components/URoomQRCode.js
/* eslint-disable no-unused-vars */ /* eslint-disable react/require-default-props */ 














var BootstrapDialog = (0,styles_styled/* default */.ZP)(Dialog/* default */.Z)(function(param) {
    var theme = param.theme;
    return {
        "& .MuiDialogContent-root": {
            padding: theme.spacing(2)
        },
        "& .MuiDialogActions-root": {
            padding: theme.spacing(1)
        }
    };
});
function BootstrapDialogTitle(props) {
    var children = props.children, onShare = props.onShare, other = (0,_object_without_properties/* default */.Z)(props, [
        "children",
        "onShare"
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(DialogTitle/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        sx: {
            m: 0,
            p: 2
        }
    }, other), {
        children: [
            children,
            onShare ? /*#__PURE__*/ (0,jsx_runtime.jsx)(IconButton/* default */.Z, {
                "aria-label": "share",
                onClick: onShare,
                sx: {
                    position: "absolute",
                    right: 8,
                    top: 8,
                    color: tokens/* tokens.token_text_grey_on_white */.T.token_text_grey_on_white
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(IosShare/* default */.Z, {})
            }) : null
        ]
    }));
}
BootstrapDialogTitle.propTypes = {
    children: (prop_types_default()).node,
    onShare: (prop_types_default()).func.isRequired
};
var roomAddress = "1Fw7wvVPhv5eioWQZ2if2zRUcHNdNBfu9r";
function URoomQRCode(param) {
    var roomLink = param.roomLink;
    var ref = (0,react.useState)(false), open = ref[0], setOpen = ref[1];
    var ref1 = (0,react.useState)(false), snackbarOpen = ref1[0], setSnackbarOpen = ref1[1];
    var ref2 = (0,react.useState)(""), snackbarMessage = ref2[0], setSnackbarMessage = ref2[1];
    var ref3 = (0,react.useState)("info"), snackbarSeverity = ref3[0], setSnackbarSeverity = ref3[1];
    var handleClickOpen = function() {
        setOpen(true);
    };
    var handleClose = function() {
        setOpen(false);
    };
    var handleShare = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function() {
            var err;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (!navigator.share) return [
                            3,
                            5
                        ];
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            3,
                            ,
                            4
                        ]);
                        return [
                            4,
                            navigator.share({
                                title: "Room QR Code",
                                text: "Scan this QR code to join the room:",
                                url: "".concat(roomLink)
                            })
                        ];
                    case 2:
                        _state.sent();
                        setSnackbarMessage("QR code shared successfully!");
                        setSnackbarSeverity("success");
                        return [
                            3,
                            4
                        ];
                    case 3:
                        err = _state.sent();
                        setSnackbarMessage("Error sharing QR code");
                        setSnackbarSeverity("error");
                        return [
                            3,
                            4
                        ];
                    case 4:
                        return [
                            3,
                            6
                        ];
                    case 5:
                        setSnackbarMessage("Sharing not supported in this browser");
                        setSnackbarSeverity("warning");
                        _state.label = 6;
                    case 6:
                        setSnackbarOpen(true);
                        return [
                            2
                        ];
                }
            });
        });
        return function handleShare() {
            return _ref.apply(this, arguments);
        };
    }();
    var handleSnackbarClose = function() {
        setSnackbarOpen(false);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(IconButton/* default */.Z, {
                "aria-controls": "menu",
                "aria-haspopup": "true",
                onClick: handleClickOpen,
                sx: {
                    color: tokens/* tokens.palette_primary */.T.palette_primary,
                    margin: "4px",
                    "&.MuiButtonBase-root.MuiIconButton-root:hover": {
                        borderRadius: "8px",
                        padding: "8px",
                        backgroundColor: tokens/* tokens.token_hairline */.T.token_hairline
                    }
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(QrCode2/* default */.Z, {
                    sx: {
                        color: tokens/* tokens.palette_primary */.T.palette_primary
                    }
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(BootstrapDialog, {
                onClose: handleClose,
                "aria-labelledby": "customized-dialog-title",
                open: open,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(BootstrapDialogTitle, {
                        id: "customized-dialog-title",
                        onShare: handleShare,
                        children: "Room QR Code"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(DialogContent/* default */.Z, {
                        dividers: true,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                            sx: {
                                border: "1px solid ".concat(tokens/* tokens.token_hairline */.T.token_hairline),
                                backgroundColor: tokens/* tokens.token_surface */.T.token_surface,
                                borderRadius: "8px"
                            },
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                alt: "address-QR-code",
                                layout: "responsive",
                                style: {
                                    maxHeight: "250px",
                                    height: "100%",
                                    maxWidth: "250px",
                                    width: "100%",
                                    padding: "8px"
                                },
                                src: "https://api.qrserver.com/v1/create-qr-code/?size=250x250&data=".concat(roomLink)
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(DialogActions/* default */.Z, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                            autoFocus: true,
                            onClick: handleClose,
                            children: "Dismiss"
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Snackbar/* default */.Z, {
                open: snackbarOpen,
                autoHideDuration: 6000,
                onClose: handleSnackbarClose,
                anchorOrigin: {
                    vertical: "top",
                    horizontal: "center"
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Alert/* default */.Z, {
                    onClose: handleSnackbarClose,
                    severity: snackbarSeverity,
                    sx: {
                        width: "100%"
                    },
                    children: snackbarMessage
                })
            })
        ]
    });
}

;// CONCATENATED MODULE: ./pages/blockquiry_connect/u/message_app.js
/* eslint-disable import/order */ /* eslint-disable no-unused-vars */ /* eslint-disable @next/next/no-img-element */ /* eslint-disable jsx-a11y/alt-text */ /* eslint-disable camelcase */ 





























var DynamicTooltip = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(517), __webpack_require__.e(7575), __webpack_require__.e(6539)]).then(__webpack_require__.bind(__webpack_require__, 16539));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(16539)
            ];
        }
    },
    ssr: false
});
var EntityTypo = (0,styled/* default */.Z)(Typography/* default */.Z)(function() {
    return {
        fontFamily: "Roboto, Arial,  sans-serif",
        fontSize: "0.87500rem",
        lineHeight: "1.00rem",
        fontWeight: 500,
        letterSpacing: ".0107142867em",
        color: tokens/* tokens.palette_primary */.T.palette_primary,
        textAlign: "left"
    };
});
var OriginTypo = (0,styled/* default */.Z)(Typography/* default */.Z)(function() {
    return {
        fontFamily: "Roboto, Arial,  sans-serif",
        fontSize: "0.87500rem",
        lineHeight: "1.00rem",
        fontWeight: 400,
        letterSpacing: ".0107142867em",
        color: tokens/* tokens.token_text_grey_on_white */.T.token_text_grey_on_white,
        textAlign: "left"
    };
});
function MessageApp() {
    var theme = (0,useTheme/* default */.Z)();
    var isMobile = (0,useMediaQuery/* default */.Z)(theme.breakpoints.down("sm"));
    var appBarHeight = isMobile ? 100 : 56;
    var cryptoSecretKey = next_sitemap_config.blockQuiry_connect_secret;
    var baseUrl = next_sitemap_config.baseUrlApp;
    var router = (0,next_router.useRouter)();
    var messageEl = (0,react.useRef)(null);
    var _query = router.query, agencyID = _query.agencyID, userName = _query.userName, roomID = _query.roomID, colorCodeBackGround = _query.colorCodeBackGround, colorCodeFont = _query.colorCodeFont;
    var ref = (0,react.useState)([]), messages = ref[0], setMessages = ref[1];
    var ref1 = (0,react.useState)([]), messagesWithEncrypted = ref1[0], setMessagesWithEncrypted = ref1[1];
    var ref2 = (0,react.useState)(""), inputValue = ref2[0], setInputValue = ref2[1];
    var ref3 = (0,react.useState)(null), socketAuthWithoutAuth = ref3[0], setSocketWithoutAuth = ref3[1];
    var ref4 = (0,react.useState)([]), getAgencyDataById = ref4[0], setGetAgencyDataById = ref4[1];
    var ref5 = (0,react.useState)(""), base64Image = ref5[0], setBase64Image = ref5[1];
    var ref6 = (0,react.useState)(null), fileType = ref6[0], setFileType = ref6[1];
    var ref7 = (0,react.useState)(""), tooltipMessage = ref7[0], setTooltipMessage = ref7[1];
    var ref8 = (0,react.useState)(false), isTooltipOpen = ref8[0], setIsTooltipOpen = ref8[1];
    var ref9 = (0,react.useState)(), roomIdState = ref9[0], setRoomIdState = ref9[1];
    var ref10 = (0,react.useState)(), getMessageAgencyId = ref10[0], setGetMessageAgencyId = ref10[1];
    var ref11 = (0,react.useState)(false), openSendConsentModal = ref11[0], setOpenSendConsentModal = ref11[1];
    var ref12 = (0,react.useState)(false), dataSaveFlag = ref12[0], setDataSaveFlag = ref12[1];
    // socket connection
    var handleConnect = function() {
        var socketUrl = baseUrl;
        fetch("/api/socket");
        if (agencyID && userName) {
            var socket = (0,esm/* default */.ZP)("".concat(socketUrl, "?", "agencyType=").concat(agencyID, "&name=").concat(userName));
            socket.on("connect", function() {});
            setSocketWithoutAuth(socket);
        } else if (roomID && userName) {
            var socket1 = (0,esm/* default */.ZP)("".concat(socketUrl, "?", "roomId=").concat(roomID, "&name=").concat(userName, "&role=user"));
            socket1.on("connect", function() {});
            setSocketWithoutAuth(socket1);
        }
    };
    var handleClickOpenSendConsentModal = function() {
        setOpenSendConsentModal(true);
    };
    var handleCloseSendConsentModal = function() {
        setOpenSendConsentModal(false);
    };
    // input value get
    var handleInputChange = function(e) {
        setInputValue(e.target.value);
    };
    // send message
    var handleSendMessage = function(e) {
        if (inputValue.trim() !== "" || base64Image) {
            var secretKey = cryptoSecretKey; // Secret key for encryption
            var encryptionText = crypto_js.AES.encrypt(inputValue, secretKey).toString();
            var encryptionBase64Image = crypto_js.AES.encrypt(base64Image, secretKey).toString();
            // The encryptionText variable now contains the encrypted data
            var eventDataSend = (0,_object_spread/* default */.Z)({
                id: messages.length + 1,
                isAgent: 0,
                message: encryptionText,
                name: userName,
                image: encryptionBase64Image,
                fileType: fileType === null || fileType === void 0 ? void 0 : fileType.type,
                colorCodeBackGround: colorCodeBackGround,
                colorCodeFont: colorCodeFont
            }, dataSaveFlag && {
                isChatStore: true
            });
            var eventData = (0,_object_spread/* default */.Z)({
                id: messages.length + 1,
                isAgent: 0,
                message: inputValue,
                name: userName,
                image: base64Image,
                fileType: fileType === null || fileType === void 0 ? void 0 : fileType.type,
                colorCodeBackGround: colorCodeBackGround,
                colorCodeFont: colorCodeFont
            }, dataSaveFlag && {
                isChatStore: true
            });
            if (socketAuthWithoutAuth) {
                socketAuthWithoutAuth.emit("sendMessage", eventDataSend);
                setMessages(function(prevMessages) {
                    return prevMessages.length === 0 ? [
                        eventData
                    ] : (0,_to_consumable_array/* default */.Z)(prevMessages).concat([
                        eventData
                    ]);
                });
                setMessagesWithEncrypted(function(prevMessages) {
                    return prevMessages.length === 0 ? [
                        eventDataSend
                    ] : (0,_to_consumable_array/* default */.Z)(prevMessages).concat([
                        eventDataSend
                    ]);
                });
                setBase64Image("");
            }
            setInputValue("");
        }
    };
    // for decline consent
    var handleAcceptDeclineConsent = function(data) {
        var secretKey = cryptoSecretKey; // Secret key for encryption
        var encryptionText = crypto_js.AES.encrypt(data, secretKey).toString();
        var eventDataSend = {
            id: messages.length + 1,
            isAgent: 0,
            message: encryptionText,
            name: userName,
            consentAccepted: (data === null || data === void 0 ? void 0 : data.includes("Accept Consent")) ? true : false,
            colorCodeBackGround: (data === null || data === void 0 ? void 0 : data.includes("Accept Consent")) ? tokens/* tokens.token_green */.T.token_green : tokens/* tokens.token_red */.T.token_red,
            colorCodeFont: tokens/* tokens.token_grey_10 */.T.token_grey_10
        };
        var eventData = {
            id: messages.length + 1,
            isAgent: 0,
            message: data,
            name: userName,
            consentAccepted: (data === null || data === void 0 ? void 0 : data.includes("Accept Consent")) ? true : false,
            colorCodeBackGround: (data === null || data === void 0 ? void 0 : data.includes("Accept Consent")) ? tokens/* tokens.token_green */.T.token_green : tokens/* tokens.token_red */.T.token_red,
            colorCodeFont: tokens/* tokens.token_grey_10 */.T.token_grey_10
        };
        if (socketAuthWithoutAuth) {
            socketAuthWithoutAuth.emit("sendMessage", eventDataSend);
            setMessages(function(prevMessages) {
                return prevMessages.length === 0 ? [
                    eventData
                ] : (0,_to_consumable_array/* default */.Z)(prevMessages).concat([
                    eventData
                ]);
            });
            setMessagesWithEncrypted(function(prevMessages) {
                return prevMessages.length === 0 ? [
                    eventDataSend
                ] : (0,_to_consumable_array/* default */.Z)(prevMessages).concat([
                    eventDataSend
                ]);
            });
            setBase64Image("");
        }
    };
    // for sending message by pressing enter
    var handleKeyPress = function(e) {
        if (e.key === "Enter") {
            e.preventDefault();
            handleSendMessage();
        }
    };
    // Copy link
    var handleCopy = function() {
        var textToCopy = "".concat(next_sitemap_config.baseUrlApp, "blockquiry_connect/u/chat_room?roomId=").concat(roomIdState);
        copy_to_clipboard_default()(textToCopy);
        setTooltipMessage("Link copied!");
        setIsTooltipOpen(true);
        setTimeout(function() {
            setIsTooltipOpen(false);
        }, 2000);
    };
    var handleHoverToolTip = function() {
        setTooltipMessage("Copy Link");
        setIsTooltipOpen(true);
    };
    var handleHoverOffToolTip = function() {
        setIsTooltipOpen(false);
    };
    // page back
    var handleBack = function() {
        router.push("/blockquiry_connect/u/select_agency");
        window.location.href = "/blockquiry_connect/u/select_agency";
    };
    // agency data get by id
    var getAgencyDataApiById = function() {
        if (agencyID || getMessageAgencyId) {
            axios/* default.get */.Z.get("/api/agencies/".concat(agencyID || getMessageAgencyId)).then(function(response) {
                setGetAgencyDataById(response.data.data); // Store the API response in state
                setGetMessageAgencyId("");
            }).catch(function(error) {
                console.error("Error fetching data:", error);
            });
        }
    };
    // image upload
    var handleImageUpload = function(event) {
        var file = event.target.files[0];
        setFileType(file);
        var reader = new FileReader();
        reader.onloadend = function() {
            var base64String = reader.result;
            setBase64Image(base64String);
            handleSendMessage();
        };
        if (file) {
            reader.readAsDataURL(file);
        }
    };
    // crome back button click
    var handleBackButtonCrome = function(event) {
        // Handle the back button event here
        event.preventDefault();
        if (socketAuthWithoutAuth) {
            socketAuthWithoutAuth.disconnect();
        }
    };
    (0,react.useEffect)(function() {
        var refreshFunction = function() {
            if (socketAuthWithoutAuth) {
                socketAuthWithoutAuth.disconnect();
            }
        };
        if (true) {
            window.addEventListener("beforeunload", refreshFunction);
            return function() {
                window.removeEventListener("beforeunload", refreshFunction);
            };
        }
    }, []);
    (0,react.useEffect)(function() {
        var handleWindowBackButton = function(event) {
            return handleBackButtonCrome(event);
        };
        window.addEventListener("popstate", handleWindowBackButton);
        return function() {
            window.removeEventListener("popstate", handleWindowBackButton);
        };
    }, []);
    (0,react.useEffect)(function() {
        var refreshFunction = function() {};
        if (true) {
            window.addEventListener("beforeunload", refreshFunction);
            return function() {
                window.removeEventListener("beforeunload", refreshFunction);
            };
        }
    }, []);
    (0,react.useEffect)(function() {
        handleConnect();
        if (agencyID) {
            getAgencyDataApiById();
        }
    }, [
        agencyID
    ]);
    (0,react.useEffect)(function() {
        if (getMessageAgencyId) {
            getAgencyDataApiById();
        }
    }, [
        getMessageAgencyId
    ]);
    (0,react.useEffect)(function() {
        if (socketAuthWithoutAuth) {
            var secretKey = cryptoSecretKey; // Secret key for encryption
            socketAuthWithoutAuth.on("getMessage", function(data) {
                if (data.id) {
                    // message decrypt
                    var messageBytes = crypto_js.AES.decrypt(data.message, secretKey);
                    var decryptedText = messageBytes.toString(crypto_js.enc.Utf8);
                    // image decrypt
                    var ImageBytes = crypto_js.AES.decrypt(data.image, secretKey);
                    var decryptedBase64Image = ImageBytes.toString(crypto_js.enc.Utf8);
                    var decryptedData = {
                        id: data.id,
                        isAgent: data.isAgent,
                        message: decryptedText,
                        name: data.name,
                        image: decryptedBase64Image,
                        fileType: data.fileType,
                        colorCodeBackGround: data.colorCodeBackGround,
                        colorCodeFont: data.colorCodeFont
                    };
                    var withOutDecryptedData = {
                        id: data.id,
                        isAgent: data.isAgent,
                        message: data.message,
                        name: data.name,
                        image: data.image,
                        fileType: data.fileType,
                        colorCodeBackGround: data.colorCodeBackGround,
                        colorCodeFont: data.colorCodeFont
                    };
                    setMessages(function(prevMessages) {
                        return prevMessages.length === 0 ? [
                            data
                        ] : (0,_to_consumable_array/* default */.Z)(prevMessages).concat([
                            decryptedData
                        ]);
                    });
                    setMessagesWithEncrypted(function(prevMessages) {
                        return prevMessages.length === 0 ? [
                            data
                        ] : (0,_to_consumable_array/* default */.Z)(prevMessages).concat([
                            withOutDecryptedData
                        ]);
                    });
                } else {
                    var withOutDecryptedData1 = {
                        id: data.id,
                        isAgent: data.isAgent,
                        message: data.message,
                        name: data.name,
                        roomId: data.roomId,
                        code: data.code,
                        agencyId: data.agencyId,
                        colorCodeBackGround: data.colorCodeBackGround,
                        colorCodeFont: data.colorCodeFont
                    };
                    withOutDecryptedData1.roomId && setRoomIdState(withOutDecryptedData1.roomId);
                    withOutDecryptedData1.agencyId && setGetMessageAgencyId(withOutDecryptedData1.agencyId);
                    setMessages(function(prevMessages) {
                        return prevMessages.length === 0 ? [
                            data
                        ] : (0,_to_consumable_array/* default */.Z)(prevMessages).concat([
                            withOutDecryptedData1
                        ]);
                    });
                    setMessagesWithEncrypted(function(prevMessages) {
                        return prevMessages.length === 0 ? [
                            data
                        ] : (0,_to_consumable_array/* default */.Z)(prevMessages).concat([
                            withOutDecryptedData1
                        ]);
                    });
                }
                if (data.code === 1006) {
                    handleConnect();
                }
                if (data.sendConsentLink == "http://Consent/") {
                // setOpenSendConsentModal(true);
                }
            });
        }
    }, [
        socketAuthWithoutAuth
    ]);
    (0,react.useEffect)(function() {
        if (messageEl) {
            messageEl.current.addEventListener("DOMNodeInserted", function(event) {
                var target = event.currentTarget;
                target.scroll({
                    top: target.scrollHeight,
                    behavior: "smooth"
                });
            });
        }
    }, []);
    // page style
    var WebStyle = {
        user_chat_section: {
            height: "100vh",
            display: "flex",
            flexDirection: "column",
            justifyContent: "flex-end"
        },
        user_chat_part: {
            display: "flex",
            justifyContent: "center"
        },
        user_chat_all_message: {
            backgroundColor: "#fff",
            width: "100%"
        },
        user_chat_all_message_head: {
            padding: "0 30px"
        },
        user_chat_message_inner: {
            height: "calc(100vh - 141px)",
            overflow: "auto",
            paddingTop: "10px",
            // Hide scrollbar for Chrome, Safari and Opera
            "&::-webkit-scrollbar": {
                display: "none"
            },
            // Hide scrollbar for IE, Edge and Firefox
            msOverflowStyle: "none",
            scrollbarWidth: "none"
        },
        messages_agent_true: {
            display: "flex",
            flexDirection: "column",
            alignItems: "start"
        },
        messages_agent_false: {
            display: "flex",
            flexDirection: "column",
            alignItems: "end"
        },
        chat_message_received: {
            maxWidth: "325px",
            width: "fit-content",
            wordBreak: "break-word",
            borderRadius: "0px 10px 10px 10px",
            margin: "2px",
            fontFamily: "Roboto,arial,sans-serif",
            color: tokens/* tokens.palette_primary */.T.palette_primary,
            fontWeight: "500",
            padding: "8px 24px 8px 14px"
        },
        chat_message_received_consent: {
            maxWidth: "325px",
            width: "fit-content",
            wordBreak: "break-word",
            borderRadius: "10px 10px 10px 10px",
            margin: "2px",
            fontFamily: "Roboto,arial,sans-serif",
            color: tokens/* tokens.token_grey_10 */.T.token_grey_10,
            fontWeight: "500",
            padding: "8px 14px"
        },
        chat_message_accept_consent: {
            backgroundColor: tokens/* tokens.token_green */.T.token_green,
            boxShadow: "rgba(100, 100, 111, 0.2) 0px 7px 29px 0px",
            "&:hover": {
                color: tokens/* tokens.token_grey_10 */.T.token_grey_10,
                backgroundColor: tokens/* tokens.token_green */.T.token_green
            }
        },
        chat_message_decline_consent: {
            backgroundColor: tokens/* tokens.token_red */.T.token_red,
            boxShadow: "rgba(100, 100, 111, 0.2) 0px 7px 29px 0px",
            "&:hover": {
                color: tokens/* tokens.token_grey_10 */.T.token_grey_10,
                backgroundColor: tokens/* tokens.token_red */.T.token_red
            }
        },
        chat_message_send: {
            borderRadius: "10px 0px 10px 10px",
            background: tokens/* tokens.palette_primary */.T.palette_primary,
            maxWidth: "325px",
            width: "fit-content",
            wordBreak: "break-word",
            margin: "2px",
            fontFamily: "Roboto,arial,sans-serif",
            color: tokens/* tokens.token_surface */.T.token_surface,
            fontWeight: "500",
            padding: "8px 14px 8px 24px"
        },
        message_font: {
            fontSize: "18px"
        },
        consent_button_font: {
            fontSize: "14px"
        },
        message_user_name: {
            fontSize: "16px",
            color: "rgba(109, 110, 111, 0.4)"
        },
        message_float_right: {
            float: "right"
        },
        message_float_left: {
            float: "left"
        }
    };
    // Consent form
    var initialValues = {
        firstName: "",
        lastName: "",
        email: "",
        phone: ""
    };
    var validationSchema = es/* object */.Ry().shape({
        firstName: es/* string */.Z_().required("Required"),
        lastName: es/* string */.Z_().required("Required"),
        email: es/* string */.Z_().email("Invalid email").required("Required"),
        phone: es/* number */.Rx().required("Required")
    });
    var onSubmit = function(values) {
        var ref;
        var agentIdFind = messages.filter(function(data) {
            return data.isAgent == 1;
        });
        var payload = {
            roomId: roomIdState,
            messages: messagesWithEncrypted,
            firstName: values === null || values === void 0 ? void 0 : values.firstName,
            lastName: values === null || values === void 0 ? void 0 : values.lastName,
            phone: values === null || values === void 0 ? void 0 : values.phone,
            email: values === null || values === void 0 ? void 0 : values.email,
            agentId: agentIdFind === null || agentIdFind === void 0 ? void 0 : (ref = agentIdFind[0]) === null || ref === void 0 ? void 0 : ref.name
        };
        axios/* default.post */.Z.post("/api/agents/saveMessages", payload).then(function(response) {
            handleAcceptDeclineConsent("Accept Consent ".concat(moment().format("MMMM Do YYYY, h:mm:ss a")));
            setDataSaveFlag(true);
            setOpenSendConsentModal(false);
        }).catch(function(error) {
            console.error(error);
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                sx: WebStyle.user_chat_section,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                    sx: WebStyle.user_chat_part,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                        sx: WebStyle.user_chat_all_message,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(AppBar/* default */.Z, {
                                sx: {
                                    backgroundColor: tokens/* tokens.token_surface */.T.token_surface,
                                    height: appBarHeight
                                },
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Toolbar/* default */.Z, {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                                                sx: {
                                                    display: "flex",
                                                    justifyContent: "center",
                                                    alignItems: "center"
                                                },
                                                onClick: function() {
                                                    handleBack();
                                                },
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ArrowBackOutlined/* default */.Z, {
                                                    sx: {
                                                        color: tokens/* tokens.palette_primary */.T.palette_primary,
                                                        cursor: "pointer",
                                                        width: "24px",
                                                        height: "24px",
                                                        marginRight: "16px"
                                                    }
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                                                sx: {
                                                    flexGrow: 1,
                                                    display: {
                                                        xs: "none",
                                                        md: "block"
                                                    }
                                                },
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Card/* default */.Z, {
                                                    elevation: 0,
                                                    sx: {
                                                        backgroundColor: "transparent"
                                                    },
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CardHeader/* default */.Z, {
                                                        sx: {
                                                            padding: 0
                                                        },
                                                        avatar: /*#__PURE__*/ (0,jsx_runtime.jsx)(Avatar/* default */.Z, {
                                                            variant: "rounded",
                                                            src: getAgencyDataById === null || getAgencyDataById === void 0 ? void 0 : getAgencyDataById.image,
                                                            alt: "country-flag",
                                                            sx: {
                                                                width: 32,
                                                                height: 24,
                                                                border: "1px solid transparent"
                                                            }
                                                        }),
                                                        title: /*#__PURE__*/ (0,jsx_runtime.jsx)(EntityTypo, {
                                                            sx: {
                                                                fontSize: "0.775rem",
                                                                lineHeight: "1.00rem"
                                                            },
                                                            children: getAgencyDataById === null || getAgencyDataById === void 0 ? void 0 : getAgencyDataById.label
                                                        }),
                                                        subheader: /*#__PURE__*/ (0,jsx_runtime.jsx)(OriginTypo, {
                                                            sx: {
                                                                fontSize: "0.775rem",
                                                                lineHeight: "0.975rem"
                                                            },
                                                            children: getAgencyDataById === null || getAgencyDataById === void 0 ? void 0 : getAgencyDataById.location
                                                        })
                                                    })
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                                                flexGrow: 1
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                                                sx: {
                                                    width: "45px"
                                                },
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(URoomQRCode, {
                                                    roomLink: "".concat(next_sitemap_config.baseUrlApp, "blockquiry_connect / u / chat_room ? roomId = ").concat(roomIdState)
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                                                sx: {
                                                    width: "45px"
                                                },
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(DynamicTooltip, {
                                                    open: isTooltipOpen,
                                                    title: tooltipMessage,
                                                    placement: "bottom",
                                                    arrow: true,
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                                        onClick: function() {
                                                            handleCopy();
                                                        },
                                                        onMouseEnter: function() {
                                                            handleHoverToolTip();
                                                        },
                                                        onMouseLeave: function() {
                                                            handleHoverOffToolTip();
                                                        },
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* default */.Z, {
                                                            sx: {
                                                                color: tokens/* tokens.palette_primary */.T.palette_primary
                                                            }
                                                        })
                                                    })
                                                })
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Toolbar/* default */.Z, {
                                        sx: {
                                            display: {
                                                xs: "block",
                                                md: "none"
                                            }
                                        },
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Card/* default */.Z, {
                                            elevation: 0,
                                            sx: {
                                                backgroundColor: "transparent"
                                            },
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CardHeader/* default */.Z, {
                                                sx: {
                                                    padding: 0
                                                },
                                                avatar: /*#__PURE__*/ (0,jsx_runtime.jsx)(Avatar/* default */.Z, {
                                                    variant: "rounded",
                                                    src: getAgencyDataById === null || getAgencyDataById === void 0 ? void 0 : getAgencyDataById.image,
                                                    alt: "country-flag",
                                                    sx: {
                                                        width: 32,
                                                        height: 24,
                                                        border: "1px solid transparent"
                                                    }
                                                }),
                                                action: /*#__PURE__*/ (0,jsx_runtime.jsx)(IconButton/* default */.Z, {
                                                    "aria-label": "settings",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(MoreVert/* default */.Z, {})
                                                }),
                                                title: /*#__PURE__*/ (0,jsx_runtime.jsx)(EntityTypo, {
                                                    sx: {
                                                        fontSize: "0.775rem",
                                                        lineHeight: "1.00rem"
                                                    },
                                                    children: getAgencyDataById === null || getAgencyDataById === void 0 ? void 0 : getAgencyDataById.label
                                                }),
                                                subheader: /*#__PURE__*/ (0,jsx_runtime.jsx)(OriginTypo, {
                                                    sx: {
                                                        fontSize: "0.775rem",
                                                        lineHeight: "0.975rem"
                                                    },
                                                    children: getAgencyDataById === null || getAgencyDataById === void 0 ? void 0 : getAgencyDataById.location
                                                })
                                            })
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                                sx: WebStyle.user_chat_all_message_head,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                                        sx: WebStyle.user_chat_message_inner,
                                        ref: messageEl,
                                        children: messages.map(function(message) {
                                            var ref;
                                            /*#__PURE__*/ return (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                                                sx: message.code == 1111 ? WebStyle.messages_agent_false : message.name == userName ? WebStyle.messages_agent_false : WebStyle.messages_agent_true,
                                                children: [
                                                    message.message && (message.message == "http://Consent/" ? /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                                                    sx: message.code == 1111 ? WebStyle.chat_message_send : message.name == userName ? WebStyle.chat_message_send : (0,_object_spread/* default */.Z)({}, WebStyle.chat_message_received_consent, WebStyle.chat_message_accept_consent),
                                                                    size: "small",
                                                                    onClick: function() {
                                                                        return setOpenSendConsentModal(true);
                                                                    },
                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                                                        sx: WebStyle.consent_button_font,
                                                                        children: "Accept Consent"
                                                                    })
                                                                }, message.id),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                                                    sx: message.code == 1111 ? WebStyle.chat_message_send : message.name == userName ? WebStyle.chat_message_send : (0,_object_spread/* default */.Z)({}, WebStyle.chat_message_received_consent, WebStyle.chat_message_decline_consent),
                                                                    size: "small",
                                                                    onClick: function() {
                                                                        return handleAcceptDeclineConsent("Decline Consent ".concat(moment().format("MMMM Do YYYY, h:mm:ss a")));
                                                                    },
                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                                                        sx: WebStyle.consent_button_font,
                                                                        children: "Decline Consent"
                                                                    })
                                                                }, message.id)
                                                            ]
                                                        })
                                                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                                                        sx: message.code == 1111 ? WebStyle.chat_message_send : message.name == userName ? WebStyle.chat_message_send : (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, WebStyle.chat_message_received), {
                                                            backgroundColor: message.colorCodeBackGround ? message.colorCodeBackGround : "#cdd2d5",
                                                            color: message.colorCodeFont
                                                        }),
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                                            sx: WebStyle.message_font,
                                                            children: message.message
                                                        })
                                                    }, message.id)),
                                                    message.image && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                                        children: [
                                                            (message === null || message === void 0 ? void 0 : (ref = message.fileType) === null || ref === void 0 ? void 0 : ref.includes("image")) && /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                                src: message.image,
                                                                style: {
                                                                    borderRadius: "10px",
                                                                    margin: "2px"
                                                                },
                                                                height: "auto",
                                                                width: "200px",
                                                                alt: "Converted to Base64"
                                                            }),
                                                            (message === null || message === void 0 ? void 0 : message.fileType) === "application/pdf" && /*#__PURE__*/ (0,jsx_runtime.jsx)("embed", {
                                                                src: message.image,
                                                                type: "application/pdf",
                                                                style: {
                                                                    borderRadius: "10px",
                                                                    margin: "2px"
                                                                },
                                                                width: "350px",
                                                                height: "300px"
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                                        sx: message.code == 1111 ? [
                                                            WebStyle.message_user_name,
                                                            WebStyle.message_float_right, 
                                                        ] : message.name == userName ? [
                                                            WebStyle.message_user_name,
                                                            WebStyle.message_float_right, 
                                                        ] : [
                                                            WebStyle.message_user_name,
                                                            WebStyle.message_float_left, 
                                                        ],
                                                        children: message.name
                                                    })
                                                ]
                                            });
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                                        sx: {
                                            display: "flex",
                                            width: "100%"
                                        },
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Paper/* default */.Z, {
                                                elevation: 0,
                                                component: "form",
                                                sx: {
                                                    p: "2px 4px",
                                                    display: "flex",
                                                    alignItems: "center",
                                                    width: "100%",
                                                    height: "47px",
                                                    border: "1px solid ".concat(tokens/* tokens.token_search_border_grey */.T.token_search_border_grey),
                                                    boxShadow: "0 4px 12px rgb(60 63 66 / 15%)",
                                                    borderRadius: "24px"
                                                },
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(InputBase/* default */.ZP, {
                                                        sx: {
                                                            ml: 1,
                                                            flex: 1
                                                        },
                                                        placeholder: "Message",
                                                        inputProps: {
                                                            "aria-label": "Message"
                                                        },
                                                        value: inputValue,
                                                        onChange: function(e) {
                                                            handleInputChange(e);
                                                        },
                                                        onKeyPress: handleKeyPress
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Divider/* default */.Z, {
                                                        sx: {
                                                            height: 28,
                                                            m: 0.5
                                                        },
                                                        orientation: "vertical"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(IconButton/* default */.Z, {
                                                        color: "primary",
                                                        sx: {
                                                            p: "10px"
                                                        },
                                                        "aria-label": "file-upload",
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                                                // accept="image/*"
                                                                id: "icon-button-file",
                                                                type: "file",
                                                                style: {
                                                                    display: "none"
                                                                },
                                                                onChange: handleImageUpload
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                                                                htmlFor: "icon-button-file",
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(IconButton/* default */.Z, {
                                                                    color: "primary",
                                                                    component: "span",
                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(UploadFileOutlined/* default */.Z, {})
                                                                })
                                                            })
                                                        ]
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(IconButton/* default */.Z, {
                                                sx: {
                                                    marginBottom: "30px"
                                                },
                                                onClick: function(e) {
                                                    return handleSendMessage(e);
                                                },
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SendOutlined/* default */.Z, {
                                                    sx: {
                                                        color: tokens/* tokens.palette_primary */.T.palette_primary,
                                                        marginLeft: "10px",
                                                        height: "30px",
                                                        width: "30px",
                                                        "&:hover": {
                                                        }
                                                    }
                                                })
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Dialog/* default */.Z, {
                open: openSendConsentModal,
                onClose: handleClickOpenSendConsentModal,
                fullWidth: true,
                maxWidth: "sm",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(formik_esm/* Formik */.J9, {
                    initialValues: initialValues,
                    validationSchema: validationSchema,
                    onSubmit: onSubmit,
                    children: function(param) {
                        var dirty = param.dirty, isValid = param.isValid, values = param.values, handleChange = param.handleChange, handleBlur = param.handleBlur;
                        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(formik_esm/* Form */.l0, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(DialogTitle/* default */.Z, {
                                    children: "Consent form"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Divider/* default */.Z, {}),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Divider/* default */.Z, {}),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(DialogContent/* default */.Z, {
                                    sx: {
                                        padding: "0px 25px 0px 25px"
                                    },
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(DialogContentText/* default */.Z, {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                                            sx: {
                                                margin: "16px 0"
                                            },
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.ZP, {
                                                item: true,
                                                container: true,
                                                spacing: 2,
                                                justify: "center",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                                                        item: true,
                                                        xs: 12,
                                                        sm: 6,
                                                        md: 6,
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(formik_esm/* Field */.gN, {
                                                            label: "First Name",
                                                            variant: "outlined",
                                                            fullWidth: true,
                                                            name: "firstName",
                                                            value: values.firstName,
                                                            component: TextField/* TextField */.n
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                                                        item: true,
                                                        xs: 12,
                                                        sm: 6,
                                                        md: 6,
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(formik_esm/* Field */.gN, {
                                                            label: "Last Name",
                                                            variant: "outlined",
                                                            fullWidth: true,
                                                            name: "lastName",
                                                            value: values.lastName,
                                                            component: TextField/* TextField */.n
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                                                        item: true,
                                                        xs: 12,
                                                        sm: 6,
                                                        md: 6,
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(formik_esm/* Field */.gN, {
                                                            label: "Email",
                                                            variant: "outlined",
                                                            fullWidth: true,
                                                            name: "email",
                                                            value: values.email,
                                                            component: TextField/* TextField */.n
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                                                        item: true,
                                                        xs: 12,
                                                        sm: 6,
                                                        md: 6,
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(formik_esm/* Field */.gN, {
                                                            label: "Phone",
                                                            variant: "outlined",
                                                            fullWidth: true,
                                                            name: "phone",
                                                            value: values.phone,
                                                            component: TextField/* TextField */.n
                                                        })
                                                    })
                                                ]
                                            })
                                        })
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Divider/* default */.Z, {}),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Divider/* default */.Z, {}),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(DialogActions/* default */.Z, {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                            onClick: handleCloseSendConsentModal,
                                            color: "primary",
                                            children: "Close"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                            variant: "text",
                                            type: "submit",
                                            onSubmit: onSubmit,
                                            children: "Accept Consent"
                                        })
                                    ]
                                })
                            ]
                        });
                    }
                })
            })
        ]
    });
}
/* harmony default export */ var message_app = (MessageApp);


/***/ }),

/***/ 42480:
/***/ (function() {

/* (ignored) */

/***/ }),

/***/ 47568:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _asyncToGenerator; }
/* harmony export */ });
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }

  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}

function _asyncToGenerator(fn) {
  return function () {
    var self = this,
      args = arguments;
    return new Promise(function (resolve, reject) {
      var gen = fn.apply(self, args);

      function _next(value) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
      }

      function _throw(err) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
      }

      _next(undefined);
    });
  };
}


/***/ })

}]);